import { render, staticRenderFns } from "./APasswordPolicies.vue?vue&type=template&id=68b37b4e&"
import script from "./APasswordPolicies.vue?vue&type=script&lang=js&"
export * from "./APasswordPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports